export default function Spinner({ className = "" }) {
  return (
    <span className={className + " spinner-border spinner-border-sm"}></span>
  );
}
